import TextToPersonalAvatarImage from '@/components/images/TextToPersonalAvatarImage';
import { CompletedStandaloneMediaAsset } from '@/types/media';
import { ImagesModalSectionProps } from '@/features/media-modal/components/common/commonTypes';
import { BlockStack, Card, Text } from '@shopify/polaris';

const PersonalAvatarAiImageSectionComponent = ({ setSelectedMedia }: ImagesModalSectionProps) => {
  const onGenerationComplete = (mediaAsset: CompletedStandaloneMediaAsset) => {
    setSelectedMedia([mediaAsset]);
  };

  return (
    <BlockStack gap="400">
      <Text as="h2" variant="headingMd" fontWeight="bold">
        Create AI Influencer
      </Text>
      <Card>
        <TextToPersonalAvatarImage
          initialPrompt="A closeup shot of a professional female model in a neutral pose, wearing basic clothing"
          hideUseAction
          onGenerationComplete={onGenerationComplete}
        />
      </Card>
    </BlockStack>
  );
};

export const PersonalAvatarAiImageSection = PersonalAvatarAiImageSectionComponent;
